module.exports = __webpack_public_path__ + "static/media/event-2.f75620ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/event-2.jpg
// module id = 548
// module chunks = 0